import React, { useEffect } from "react";
import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import CbLogo from "../../Images/CbLogo.svg";
import { AiDashboard } from "./AiDashboard";
import "./Chatbot.css";
import { ChatAnswer } from "./Chatanswer";
import { SBNotify } from "../utils/sbNotify";
import { sbaAxios } from "../utils/sbaAxios";
import { chatQuery,insertPrompt, getPrompts, genaiChat, genaiChatDirectCall, genaiChatPromptStatusCheck } from "../../config/apiConfig";
import ChatbotSidebar from "./ChatbotSidebar";
import PromptInput from "./PromptInput";
import TryPrompts from "./TryPrompts";
import DashboardContent from "./DashboardContent";
import NegativeFeedbackInput from "./NegativeFeedbackInput";

export const ChatBot = ({chatAccess}) => {
  const data = {
    default: true,
    chatAns: false,
    dashboardAi: false,
  };

  const [recentPrompts, setRecentPrompts] = useState([]); // State to store recent prompts
  const [show, setShow] = useState(false);
  const [Content, setContent] = useState(data);
  const [apiResponse, setApiResponse] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isFetchingResponse, setIsFetchingResponse] = useState(false);
  const [isSeeMore, setisSeeMore] = useState(false);
  const [currentPrompt, setCurrentPrompt] = useState("");
  const [inputText, setInputText] = useState("");
  const maxCharacters = 500;
  const [isFeedbackMode, setIsFeedbackMode] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [sendFeedback, setSendFeedback] = useState(false);
  const [promptId, setPromptId] = useState(0);
  const [isReOrdered, setIsReOrdered] = useState(false);
  const [isChatAccessed,setIsChatAccessed]=useState(false);
  const [latestResponseId, setLatestResponseId]=useState(0);
  useEffect(()=>{
    setIsChatAccessed(chatAccess)
  },[chatAccess])
  useEffect(()=>{
    if(!isFeedbackMode){
      setSendFeedback(false);
      setRemarks("");
    }
  }, [isFeedbackMode]);

  const handleInputChange = (e) => {
    setInputText(e.target.value.slice(0, maxCharacters));
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value.slice(0, maxCharacters));
  };

  const handleTextClick = (text) => {
    setInputText(text);
  };

  const handleClose = () => {
    setShow(false);
    setContent({ ...data, default: true, chatAns: false, dashboardAi: false });
  };
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (errorMessage !== null) {
      setTimeout(() => setErrorMessage(null), 5000);
    }
  }, [errorMessage]);

  const handleStartNew = (mode) => {
    if (mode === "New") {
      setInputText("");
      setCurrentPrompt("");
      setContent({
        ...data,
        default: true,
        chatAns: false,
        dashboardAi: false,
      });
    }
  };

  const insertPromptLog = async(promptId, prompt, response, status, sql) => {
    const postData = {
      promptLogId: promptId,
      prompt: prompt,
      promptResponse: response,
      userId: 0,
      status: status,
      ipAddress: "",
      feedback: null,
      remarks:"",
      SqlQueryText:sql || null,
      createdDate: new Date().toISOString(),
    };
    try {
     let promptLogId =  await sbaAxios({
        url: insertPrompt,
        method: "post",
        data: postData,
      });
      return promptLogId;
    } catch (e) {
      console.log(e);
    };
  };

  const getRecentPrompts = async (responseStatus, responseId) => {
    try {
      const promptList = await sbaAxios({
        url: getPrompts,
        method: 'get',
      });
  
      const recentPromptsList = promptList.map((item) => {
        let promptResponse = {};
        try {
          promptResponse = JSON.parse(item?.PromptResponse);
        } catch (err) {
          //console.error("Invalid JSON in PromptResponse:", item?.PromptResponse);
        }
  
        const isProcessing = promptResponse?.status === "processing";
        const request_id = promptResponse?.request_id;
        const promptID = item?.PromptLogId;
  
        if (isProcessing) {
          // setTimeout(() => {
          //   getPromptStatus(promptID, request_id);
          // }, 10000);
         
        }
  
        return {
          text: item?.Prompt?.trim(),
          edited: new Date(item?.CreatedDate),
          isFavourite: false,
          promptID,
          status:item.Status ,
          isProcessing,
        };
      });
  
      setRecentPrompts(recentPromptsList);
    } catch (e) {
      console.error("Failed to fetch recent prompts:", e);
      setRecentPrompts([]);
    }
  };
  
  
  

  useEffect(()=>{
      getRecentPrompts()
  },[show]);
  
  useEffect(() => {
  
    if (latestResponseId !== 0 && latestResponseId !== null) {
      const timeoutId = setTimeout(() => {
        const targetElement = document.getElementById(latestResponseId);
  
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 50); // 50ms delay (adjust as needed)
  
      return () => clearTimeout(timeoutId);
    }
  }, [latestResponseId]);

  const generateClick = async (mode,prompt) => {
    setIsFetchingResponse(true);
    const controller = new AbortController(); // Create an instance to control the request
    const signal = controller.signal; // Signal for axios to listen for abort
    try {
      // const DataToPass = {
      //   prompt: inputText,
      // };
      if (prompt === "") {
        SBNotify({ Msg: "Please  Give the Prompt", type: "error" });
        return;
      }
      const DataToPass = prompt;
        const requestPromise = sbaAxios({
          url: genaiChat,
          method: "post",
          data: DataToPass,
          signal: signal,
        });
        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(() => {
            controller.abort();
            reject(new Error("Something went wrong. Please try again later"));
          }, 90000)
        );
        const response = await Promise.race([requestPromise, timeoutPromise]);
        setPromptId(response["PromptLog"]);
        setLatestResponseId(response["PromptLog"]);
        setApiResponse(response);
        setCurrentPrompt(prompt);
        setIsFetchingResponse(false);
        
        if (mode === "chatans") {
            setContent({
              ...data,
              default: false,
              chatAns: true,
              dashboardAi: false,
            });
            const respStatus = response?.status ? "Processing" : "Success"
            getRecentPrompts(respStatus,response["PromptLog"]);
            setInputText("");
        }
        if (mode === "dashboard") {
          setContent({
            ...data,
            default: false,
            chatAns: false,
            dashboardAi: true,
          });
        } 
    } catch (e) {
      setIsFetchingResponse(false);
      setErrorMessage(
        "We apologize for the inconvenience, but due to technical issues, our search service is temporarily unavailable. Please give us another try in a little while we're working to resolve the issue as quickly as possible. Thank you for your patience and understanding!"
      );
    }
  };

  const handleRegenerate = (regenPrompt) => {
    setInputText(regenPrompt);
    generateClick("chatans",regenPrompt);
  };

  return (
    <>
      {
        <div style={{ position: "absolute", top: 0, bottom: 0 }} className="ChatbotContainer">
          <button
            className={`${isChatAccessed ? 'cb-btn' : 'cb-btn-disabled'}`}
            onClick={()=>{isChatAccessed && handleShow()}}
            style={{ bottom: "50px" }}
            disabled={!isChatAccessed}
          >
            <img src={CbLogo} alt="ChatBot-Icon" width={16} height={16} />
            Intelligent Assistant
          </button>
          <Offcanvas
            className={"cb"}
            show={show}
            onHide={handleClose}
            placement={"bottom"}
            scroll={true}
          >
            <div className="chatbot d-flex flex-grow-1">
              <ChatbotSidebar
                recents={recentPrompts}
                handleStartNew={handleStartNew}
                setInputText={setInputText}
                setRecents={setRecentPrompts}
                setIsReOrdered={setIsReOrdered}
              />
              <main className="flex-1">
                <div className="d-flex ms-4">
                  {Content.chatAns && (
                    <h2 className="mt-2 ms-4 text-dark fw-bold  text-center">
                      {" "}
                      Performance Data{" "}
                    </h2>
                  )}
                  <Offcanvas.Header className="py-3 mt-2 ms-auto " closeButton>
                    {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title>  */}
                  </Offcanvas.Header>
                </div>
                <Offcanvas.Body>
                  {Content.default && (
                    <div className="px-5">
                      <div className="pt-5">
                        <h2 className="mb-4 text-dark fw-bold  text-center">
                          Asset Edge: Powering Your Decisions
                        </h2>
                        <DashboardContent />

                        <h3 className="mb-4 fs-5 text-center text-dark-emphasis">
                          Analyze markets effortlessly with powerful AI-driven
                          insights
                        </h3>
                        {errorMessage && (
                          <div
                            className="alert alert-danger mt-2"
                            style={{ textAlign: "center" }}
                          >
                            {errorMessage}
                          </div>
                        )}
                      </div>
                      </div>)}
                      {
                        isFeedbackMode ? 
                        <NegativeFeedbackInput
                          inputText={remarks}
                          handleInputChange={handleRemarksChange}
                          maxCharacters={maxCharacters}
                          handleSendFeedback={setSendFeedback}
                          styling={Content.default ? "": "mt-4 promptabsolutecontent"}
                        />:
                        <PromptInput
                          inputText={inputText}
                          handleInputChange={handleInputChange}
                          maxCharacters={maxCharacters}
                          generateClick={generateClick}
                          isFetchingResponse={isFetchingResponse}
                          styling={Content.default ? "": "mt-4 promptabsolutecontent"}
                        />
                      }
                      {Content.default && (
                    <div className="px-5">
                      <div className="pt-1">
                        <TryPrompts
                          handleTextClick={handleTextClick}
                          isSeeMore={isSeeMore}
                          isReOrdered={isReOrdered}
                        />
                      </div>
                      <button
                        className="p-sm-btn SBA_hand"
                        onClick={(setButtonLabel) => {
                          setisSeeMore(!isSeeMore);
                        }}
                        style={{ float: "right" }}
                      >
                        {isSeeMore === true ? "See Less..." : "See More..."}
                      </button>
                    </div>
                  )}
                  
                  {Content.chatAns && (
                    <>
                      {/* <p className='m-0 fs-4 fw-semibold text-dark'>Asset Edge</p> */}
                      <ChatAnswer
                        response={apiResponse}
                        reGenerateResponse={handleRegenerate}
                        inputText={currentPrompt}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        remarks={remarks}
                        setRemarks={setRemarks}
                        setIsFeedbackMode={setIsFeedbackMode}
                        sendFeedback={sendFeedback}
                        promptId={promptId}
                      ></ChatAnswer>
                    </>
                  )}
                  {Content.dashboardAi && <AiDashboard></AiDashboard>}
                </Offcanvas.Body>
              </main>
            </div>
          </Offcanvas>
        </div>
      }

      {/* <ToastContainer></ToastContainer> */}
    </>
  );
};


const getPromptStatus=(logID,requestID)=>{
try {
  // sbaAxios({url:genaiChatPromptStatusCheck+logID, method: "post",
  // data: requestID}).then(res=>{
  // })
} catch (error) {
  
}
}
